<template>
  <div>
    <LayerToggle />
    <!-- <HudSlider /> -->
    <button
      id="searchButton"
      type="button"
      class="btn"
      :class="searchedClass"
      @click="directionsSearched"
    >
      Directions to {{ this.geocoderData.locationName }}
    </button>
    <!-- <button
      id="mapInfo"
      @click="isActive = !isActive"
      :class="{ big: isActive }"
    >
      <h6>mapInfo</h6>
      <div>Mode: {{ mapMode }}</div>
      <div>Center: {{ hudCenter }}</div>
      <div>Zoom: {{ hudZoom }}</div>
      <div>POIs Ready for GH Calc: {{ localMapIsStatic }}</div>
      <div>Current Marker: {{ currentMarker }}</div>
    </button> -->
    <!-- <div id="markerList">
      <h6>markerList</h6>
      <div v-for="(item, index) in markerList" :key="index">
        {{ item.id }}:
        {{
          [
            Math.round(item._lngLat.lat * 1000) / 1000,
            Math.round(item._lngLat.lng * 1000) / 1000
          ]
        }}
      </div>
    </div> -->
    <div id="drawControls">
      <button
        id="crosshairButton"
        type="button"
        :class="buttonPlacement"
        @click="hudDropMarker"
        data-toggle="tooltip"
        data-placement="left"
        title="Drop Marker"
      >
        <i class="fas fa-map-marker-alt fa-2x"></i>
      </button>
      <button
        id="freeDrawButton"
        type="button"
        class="btn btn-info"
        :class="buttonPlacement"
        @click="toggleFreeDrawMode"
        data-toggle="tooltip"
        data-placement="left"
        title="Free Draw"
      >
        <i class="far fa-edit fa-3x"></i>
      </button>
      <button
        id="undoButton"
        type="button"
        class="btn btn-warning"
        :class="buttonPlacement"
        @click="undoLastMarker"
        data-toggle="tooltip"
        data-placement="left"
        title="Undo"
      >
        <i class="fas fa-undo-alt fa-2x"></i>
      </button>
      <button
        id="createButton"
        type="button"
        class="btn btn-info"
        :class="buttonPlacement"
        @click="toggleCrosshair"
        data-toggle="tooltip"
        data-placement="top"
        title="Create Route"
      >
        <span v-show="mapMode != 'crosshairMode'">
          <i class="fas fa-map-marked-alt fa-3x"></i>
        </span>
        <span v-show="mapMode == 'crosshairMode'">
          <i class="fas fa-times fa-3x"></i>
        </span>
      </button>
    </div>
    <div id="hud"></div>
  </div>
</template>

<script>
import LayerToggle from "@/components/LayerToggle.vue";
// import HudSlider from "@/components/HudSlider.vue";
import { mapState } from "vuex";
import $ from "jquery";

export default {
  components: {
    LayerToggle
    // HudSlider
  },
  props: {
    stats: {
      type: Object
    },
    geocoderData: {
      type: Object
    },
    currentMarker: {
      type: String
    },
    localMapIsStatic: {
      type: Boolean
    },
    markerList: {
      type: Array
    },
    hudZoom: {
      type: Number
      // default: 12
      // required: true
    },
    hudCenter: {
      type: Array
    },
    childPropCaught: {
      type: String
    }
  },
  computed: {
    searchedClass() {
      return this.mapMode == "searchMode" ? "searchedClass" : "";
    },
    buttonPlacement() {
      return this.mapMode == "crosshairMode"
        ? "crosshairClass"
        : this.mapMode == "freeDrawMode"
        ? "freeDrawClass"
        : "exploreClass";
      // : this.mapMode == "exploreMode"
      // ? "exploreClass"
      // : "";
    },
    //Remember ...mapState is a shorthand way to bring Vuex State into a Component and have it mapped to the same name
    //Another way would be just writing a computed function such as >>> mapMode_forhud() {return this.$store.state.mapMode}
    ...mapState(["mapMode", "POIList", "mapIsStatic", "uiRouteType"]),
    currentZoom() {
      return Math.round(this.hudZoom * 100) / 100;
    }
  },

  data() {
    return {
      isActive: false,
      finalValue: this.childPropCaught
    };
  },
  methods: {
    dropCoffeeMarkers: function() {
      this.$store.commit("toggleActiveLayers", "coffee");
      this.$emit("dropCoffeeMarkers");
    },
    dropMuseumMarkers: function() {
      this.$store.commit("toggleActiveLayers", "museums");
      this.$emit("dropMuseumMarkers");
    },
    dropVolunteerMarkers: function() {
      this.$store.commit("toggleActiveLayers", "volunteer");
      this.$emit("dropVolunteerMarkers");
    },
    dropBikeShopMarkers: function() {
      this.$store.commit("toggleActiveLayers", "bikeshops");
      this.$emit("dropBikeShopMarkers");
    },
    dropRestaurantMarkers: function() {
      this.$store.commit("toggleActiveLayers", "restaurants");
      this.$emit("dropRestaurantMarkers");
    },
    dropBreweryMarkers: function() {
      this.$store.commit("toggleActiveLayers", "breweries");
      this.$emit("dropBreweryMarkers");
    },
    dropBarMarkers: function() {
      this.$store.commit("toggleActiveLayers", "bars");
      this.$emit("dropBarMarkers");
    },
    dropFarmMarkers: function() {
      this.$store.commit("toggleActiveLayers", "farm");
      this.$emit("dropFarmMarkers");
    },
    directionsSearched: function() {
      this.$store.commit("toggleStateMapMode", "geolocateMode");
      this.$emit("directionsSearched");
    },
    // toggleSafeRouting: function() {
    //   this.$store.commit("toggleSafeRouting");
    //   this.$emit("toggleSafeRouting");
    // },
    undoLastMarker: function() {
      this.$emit("undoLastMarker");
    },
    toggleFreeDrawMode: function() {
      this.$store.commit("toggleStateFreeDrawMode");
      this.$emit("toggleFreeDrawMode");
    },
    hudDropMarker: function() {
      this.$emit("hudDropMarker"); //Hud Tells Map to Add Marker, and Map will subsequently broadcast the Marker to Vuex Store POIList
    },
    toggleCrosshair: function() {
      this.$store.commit("toggleStateMapMode");
      this.$emit("toggleCrosshair");
    },
    routeChangeFromHud: function() {
      this.$store.commit("toggleRouteProfile");
    }
  },
  mounted() {
    //Initalize Tooltips as discussed -- https://getbootstrap.com/docs/4.0/components/tooltips/
    $(function() {
      $('[data-toggle="tooltip"]').tooltip();
    });

    //Autohide Tooltips after being clicked -- https://stackoverflow.com/questions/25075807/auto-hide-bootstrap-tooltip
    $(function() {
      $(document).on("shown.bs.tooltip", function(e) {
        setTimeout(function() {
          $(e.target).tooltip("hide");
        }, 1000);
      });
    });
  }
};
</script>

<style lang="scss" scoped>
$hudcolor: #363636;

@media (max-width: 812px) {
  #yelpLinks {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    width: 35vw;
    height: 130px;
  }
}

@media (min-width: 812px) {
  #yelpLinks {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    width: 400px;
    height: 8vh;
  }
}

#yelpLinks {
  display: grid;
  border: solid 1px grey;
  align-items: center;
  justify-items: center;

  position: absolute;
  left: 0;
  right: 0;
  margin: auto;

  bottom: 11vh;

  background-color: rgba(255, 255, 255, 0.555);

  /*animations & transitions*/
  -webkit-transition: all 0.1s;
  -moz-transition: all 0.1s;
  -o-transition: all 0.1s;
  transition: all 0.1s;

  button {
    .fa-coffee {
      color: #a5a5a5;
      stroke: black;
      stroke-width: 8;
    }
    .fa-landmark {
      color: #6aa4be;
      stroke: black;
      stroke-width: 8;
    }
    .fa-heart {
      color: #c41c1c;
      stroke: black;
      stroke-width: 8;
    }
    .fa-biking {
      color: #358680;
      stroke: black;
      stroke-width: 8;
    }
    .fa-utensils {
      color: #868686;
      stroke: black;
      stroke-width: 8;
    }
    .fa-beer {
      color: #e0b72e;
      stroke: black;
      stroke-width: 8;
    }
    .fa-glass-martini-alt {
      color: #791010;
      stroke: black;
      stroke-width: 8;
    }
    .fa-seedling {
      color: #169616;
      stroke: black;
      stroke-width: 8;
    }

    outline: none;
    border: none;
    background: none;

    &:hover {
      transform: scale(1.3);
      /*animations & transitions*/
      -webkit-transition: all 0.1s;
      -moz-transition: all 0.1s;
      -o-transition: all 0.1s;
      transition: all 0.1s;
    }
  }
}

#searchButton {
  &:focus {
    box-shadow: none;
  }

  top: 55px;
  display: inline-block;
  justify-content: center;
  align-items: center;
  width: 30%;
  min-width: 240px;

  //These 4 lines are the best way to center any div
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;

  //Adjust the font-size dynamically to fit the button width
  font-size: 1em;
  outline: none;

  color: white;
  /*animations & transitions*/
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;

  &.searchedClass {
    position: absolute;
    top: 115px;
    background-color: teal;
    box-shadow: 2px 2px 6px #464646;
    border: solid 1px #363636;
  }
}

#drawControls {
  position: absolute;
  display: flex;
  align-items: flex-end; // Or on child item align-self: flex-end; -- FINALLY understanding flex!
  justify-content: flex-end; //Stupidly enough justify-items: flex-end does not work...
  width: 90px;
  height: 90px;
  bottom: calc(12vh + 30px); //hud height + mapbox logo height + 5px buffer
  right: 20px;

  > button {
    position: absolute;
    width: 70px;
    height: 70px;
    border-radius: 40px;
    border: solid 1px rgb(0, 0, 0);
    outline: none;
    font-size: 10px;
    bottom: 0px;
    right: 0px;
    color: white;
    font-weight: 600;
    /*animations & transitions*/
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
  }

  #crosshairButton {
    color: brown;

    &.crosshairClass {
      bottom: 160px;
      box-shadow: 2px 2px 6px #464646;
    }

    &.freeDrawClass {
      bottom: 80px;
    }
  }

  #freeDrawButton,
  #createButton {
    background-color: teal;
  }

  #createButton {
    box-shadow: 2px 2px 6px #464646;
    &.crosshairClass {
      background-color: grey;
    }
    &.freeDrawClass {
      background-color: grey;
    }
  }

  #undoButton {
    &.crosshairClass {
      box-shadow: 2px 2px 6px #464646;
      bottom: 80px;
    }
    &.freeDrawClass {
      box-shadow: 2px 2px 6px #464646;
      bottom: 80px;
    }
  }

  > #freeDrawButton.crosshairClass {
    box-shadow: 2px 2px 6px #464646;
    transform: scale(0.6);
    bottom: 40px;
    right: 60px;
  }

  > #freeDrawButton.freeDrawClass {
    transform: scale(0.6);
    bottom: 40px;
    right: 60px;
    z-index: 2;
  }
  > #createButton.freeDrawClass {
    transform: scale(0.6);
    bottom: 40px;
    right: 60px;
  }
}

.custom-control-label::before {
  border-color: brown;
  background-color: brown;
  border: none;
}

.custom-control-input:checked ~ .custom-control-label::before {
  border-color: rgb(3, 94, 18);
  background-color: rgb(3, 94, 18);
}

#mapInfo {
  &.big {
    height: auto;
    width: auto;
  }
  height: 40px;
  width: 40px;
  overflow: hidden;
  font-size: 12px;
  line-height: 15px;
  font-weight: bold;
  position: absolute;
  left: 10px;
  bottom: calc(10vh + 6vw + 50px);
  // top: calc(38.5px + 40px + 10px); //height of nav + height of logo + buffer

  // bottom: calc(
  //   20vh + 29px + 5px
  // ); //hud height + mapbox logo height + 5px buffer
  background-color: rgba(253, 253, 253, 0.5);
  border: solid 1px grey;
  border-radius: 4px;
  padding: 5px;
}

#markerList {
  text-align: start;
  font-size: 11px;
  line-height: 15px;
  min-height: 10vh;
  max-height: 20vh;
  width: calc(15vw - 30px); //If the search bar is 70vw
  position: absolute;
  top: calc(
    38.5px + 40px + 10px + 120px
  ); //height of nav + height of logo + buffer
  left: 10px;
  font-weight: bold;
  background-color: rgba(253, 253, 253, 0.5);
  border: solid 1px grey;
  border-radius: 4px;
  padding: 5px;
  overflow-y: scroll;
}

#hud {
  position: absolute;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 2px;
  background-color: white;
  bottom: 0px;
  height: 12vh;
  padding: 0px;
  margin: 0px;
  align-items: stretch;
  // border-top: solid 2px grey;
  background-color: $hudcolor;
  width: 100vw;
  font-size: 13px;

  > * {
    display: flex;
    text-align: center;
    align-self: center;
    justify-self: center;
    color: white;
  }
}
</style>
